import { render, staticRenderFns } from "./WidgetCategoryReviewsSquareGalleryPc.vue?vue&type=template&id=1caa9055"
import script from "./WidgetCategoryReviewsSquareGalleryPc.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsSquareGalleryPc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports